/**
 * Swaps the mega menu's featured collection image/title when hovering
 * (or focusing) a child link that declares a `data-hover-image`.
 * Reverts to the column's default image when the link loses hover/focus.
 */
(function () {
  function getGrid(link) {
    return link.closest('[data-menu-grid-id]');
  }

  function cacheDefaults(img, titleEl) {
    if (img.dataset.defaultSrc === undefined) {
      img.dataset.defaultSrc = img.currentSrc || img.getAttribute('src') || '';
      img.dataset.defaultSrcset = img.getAttribute('srcset') || '';
    }
    if (titleEl && titleEl.dataset.defaultText === undefined) {
      titleEl.dataset.defaultText = titleEl.textContent;
    }
  }

  function handleEnter(event) {
    var link = event.target.closest('[data-hover-image]');
    if (!link) return;

    var grid = getGrid(link);
    if (!grid) return;

    var img = grid.querySelector('.resource-card__image');
    if (!img) return;
    var titleEl = grid.querySelector('.resource-card__title');

    cacheDefaults(img, titleEl);

    img.setAttribute('srcset', link.dataset.hoverImageSrcset || '');
    img.setAttribute('src', link.dataset.hoverImage);

    if (titleEl && link.dataset.hoverTitle) {
      titleEl.textContent = link.dataset.hoverTitle;
    }
  }

  function handleLeave(event) {
    var link = event.target.closest('[data-hover-image]');
    if (!link) return;

    var related = event.relatedTarget || (event.target && event.target.ownerDocument
      ? event.target.ownerDocument.activeElement
      : null);
    if (related && link.contains(related)) return;

    var grid = getGrid(link);
    if (!grid) return;

    var img = grid.querySelector('.resource-card__image');
    if (!img || img.dataset.defaultSrc === undefined) return;
    var titleEl = grid.querySelector('.resource-card__title');

    img.setAttribute('srcset', img.dataset.defaultSrcset || '');
    img.setAttribute('src', img.dataset.defaultSrc);

    if (titleEl && titleEl.dataset.defaultText !== undefined) {
      titleEl.textContent = titleEl.dataset.defaultText;
    }
  }

  document.addEventListener('pointerover', handleEnter);
  document.addEventListener('focusin', handleEnter);
  document.addEventListener('pointerout', handleLeave);
  document.addEventListener('focusout', handleLeave);
})();
